import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let Tools = class Tools extends Vue {
    faceOne2OneImg = require('@blade-sxp/tools/assets/images/faceOne2One.svg');
    faceOne2NImg = require('@blade-sxp/tools/assets/images/faceOne2N.svg');
    cards = [
        {
            id: 'one-one',
            name: this.$t('face1v1'),
            routerName: 'faceOne2One',
            path: '/tools/faceOne2One',
            code: '07',
            img: this.faceOne2OneImg,
        },
        {
            id: 'one-more',
            name: this.$t('face1vN'),
            routerName: 'faceOne2N',
            path: '/tools/faceOne2N',
            code: '07',
            img: this.faceOne2NImg,
        },
    ];
    handleJump(routerName) {
        this.$router.push({ name: routerName });
    }
};
Tools = __decorate([
    Component({
        name: 'Tools',
        components: { AuthItem },
        i18n: {
            messages: {
                en: {
                    face1v1: 'Face Comparison(1:1)',
                    face1vN: 'Face Comparison(1:N)',
                },
                zh: {
                    face1v1: '人脸1:1',
                    face1vN: '人脸1:N',
                },
            },
        },
    })
], Tools);
export default Tools;
